/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import GuardianRouteLinkItem from './GuardianRouteLinkItem';
import ChildIcon from 'icons/ChildIcon';

const messages = defineMessages({
  title: {id: 'navigation.children'},
});

const ChildrenItem = () => (
  <GuardianRouteLinkItem
    iconBefore={ChildIcon}
    route="midas/guardian/children"
    title={messages.title}
  />
);

export default ChildrenItem;
